import React from 'react';
import UploadContent from './UploadContent';

const UtilityBills = () => {
    return <UploadContent type='Utility Bills'/>;
};

export default UtilityBills;